import {
  CameraDevice,
  Customer,
  CustomerFleetSummary,
  AlertItem,
  SimCard,
  Subscription,
  PaymentRecord,
  PlanItem,
  InventoryItem,
  EmergencyEvent,
  AdminUser,

} from '../types';

export const MOCK_DEVICES: CameraDevice[] = [
  {
    id: 'cam-001',
    serial: 'VST-48201-LRB',
    name: 'Main Gate Entrance (PTZ)',
    model: 'The Eye 4G',
    ownerId: 'cust-101',
    ownerName: 'Monrovia Breweries Ltd',
    ownerEmail: 'ops@monrovia-breweries.com',
    status: 'offline',
    vuid: null,
    vuidState: 'inactivated',
    relayCluster: 'relay-cluster-monrovia',
    relayHost: 'relay-01.lr.mywatchman.net',
    isRelayReachable: true,
    hasLocation: true,
    latitude: 6.3156,
    longitude: -10.8074,
    address: 'Bushrod Island, Industrial Zone, Monrovia',
    lastHeartbeat: new Date(Date.now() - 1000 * 60 * 180).toISOString(),
    isBlocked: false,
    firmwareVersion: 'v48.2.11-build2025',
    sdkVersion: 'Eye4-v6.8.1-linux',
    offlineReason: 'sim_lapsed',
    offlineReasonDetail: 'Eye4 VUID resolution returned 550 inactivated (Data bundle exhausted)',
    cloudRecording: {
      isRecording: false,
      lastClipTime: new Date(Date.now() - 1000 * 60 * 185).toISOString(),
      retentionDays: 30,
      status: 'stopped',
    },
    sim: {
      id: 'sim-01',
      deviceId: 'cam-001',
      deviceSerial: 'VST-48201-LRB',
      iccid: '8923100018274619283',
      carrier: 'Lonestar MTN Liberia',
      signalDbm: -98,
      dataUsageMb: 10240,
      dataLimitMb: 10240,
      creditBalanceUsd: 0.00,
      expiryDate: new Date(Date.now() - 1000 * 60 * 60 * 24).toISOString(),
      isLapsed: true,
      isAboutToLapse: false,
      lastTopupDate: '2026-08-14T09:30:00Z',
    },
  },
  {
    id: 'cam-002',
    serial: 'VST-48202-LRB',
    name: 'Perimeter Fence North',
    model: 'The Eye Mini Solar',
    ownerId: 'cust-101',
    ownerName: 'Monrovia Breweries Ltd',
    ownerEmail: 'ops@monrovia-breweries.com',
    status: 'online',
    vuid: 'LR0048202VUID',
    vuidState: 'resolved',
    relayCluster: 'relay-cluster-monrovia',
    relayHost: 'relay-01.lr.mywatchman.net',
    isRelayReachable: true,
    hasLocation: true,
    latitude: 6.3168,
    longitude: -10.8062,
    address: 'Bushrod Island, Perimeter North',
    lastHeartbeat: new Date(Date.now() - 1000 * 45).toISOString(),
    isBlocked: false,
    firmwareVersion: 'v48.2.09',
    sdkVersion: 'Eye4-v6.8.1-linux',
    offlineReason: 'healthy',
    cloudRecording: {
      isRecording: true,
      lastClipTime: new Date(Date.now() - 1000 * 120).toISOString(),
      retentionDays: 30,
      status: 'healthy',
    },
    sim: {
      id: 'sim-02',
      deviceId: 'cam-002',
      deviceSerial: 'VST-48202-LRB',
      iccid: '8923100018274619284',
      carrier: 'Orange Liberia',
      signalDbm: -72,
      dataUsageMb: 4120,
      dataLimitMb: 15360,
      creditBalanceUsd: 14.50,
      expiryDate: new Date(Date.now() + 1000 * 60 * 60 * 24 * 18).toISOString(),
      isLapsed: false,
      isAboutToLapse: false,
      lastTopupDate: '2026-09-01T12:00:00Z',
    },
  },
  {
    id: 'cam-003',
    serial: 'VST-59104-ROV',
    name: 'Freeport Pier 3 Loading Bay',
    model: 'The Eye 4G',
    ownerId: 'cust-102',
    ownerName: 'APM Terminals Freeport',
    ownerEmail: 'security@apmterminals.lr',
    status: 'offline',
    vuid: 'LR0059104VUID',
    vuidState: 'resolved',
    relayCluster: 'relay-cluster-monrovia',
    relayHost: 'relay-02.lr.mywatchman.net',
    isRelayReachable: false,
    hasLocation: true,
    latitude: 6.3382,
    longitude: -10.7964,
    address: 'Monrovia Freeport, Berth 3',
    lastHeartbeat: new Date(Date.now() - 1000 * 60 * 12).toISOString(),
    isBlocked: false,
    firmwareVersion: 'v49.1.02',
    sdkVersion: 'Eye4-v6.8.1-linux',
    offlineReason: 'wedged_p2p',
    offlineReasonDetail: 'P2P handshake acknowledged but video channel stalled (Needs driver reboot)',
    cloudRecording: {
      isRecording: false,
      lastClipTime: new Date(Date.now() - 1000 * 60 * 50).toISOString(),
      retentionDays: 60,
      status: 'stopped',
    },
    sim: {
      id: 'sim-03',
      deviceId: 'cam-003',
      deviceSerial: 'VST-59104-ROV',
      iccid: '8923100018274619285',
      carrier: 'Orange Liberia',
      signalDbm: -68,
      dataUsageMb: 8200,
      dataLimitMb: 20480,
      creditBalanceUsd: 22.00,
      expiryDate: new Date(Date.now() + 1000 * 60 * 60 * 24 * 25).toISOString(),
      isLapsed: false,
      isAboutToLapse: false,
    },
  },
  {
    id: 'cam-004',
    serial: 'VST-59105-ROV',
    name: 'Customs Warehouse Entrance',
    model: 'The Eye Mini Solar',
    ownerId: 'cust-102',
    ownerName: 'APM Terminals Freeport',
    ownerEmail: 'security@apmterminals.lr',
    status: 'online',
    vuid: 'LR0059105VUID',
    vuidState: 'resolved',
    relayCluster: 'relay-cluster-monrovia',
    relayHost: 'relay-01.lr.mywatchman.net',
    isRelayReachable: true,
    hasLocation: true,
    latitude: 6.3395,
    longitude: -10.7951,
    address: 'Monrovia Freeport, Warehouse B',
    lastHeartbeat: new Date(Date.now() - 1000 * 30).toISOString(),
    isBlocked: false,
    firmwareVersion: 'v49.1.02',
    sdkVersion: 'Eye4-v6.8.1-linux',
    offlineReason: 'healthy',
    cloudRecording: {
      isRecording: true,
      lastClipTime: new Date(Date.now() - 1000 * 90).toISOString(),
      retentionDays: 60,
      status: 'healthy',
    },
    sim: {
      id: 'sim-04',
      deviceId: 'cam-004',
      deviceSerial: 'VST-59105-ROV',
      iccid: '8923100018274619286',
      carrier: 'Lonestar MTN Liberia',
      signalDbm: -75,
      dataUsageMb: 11400,
      dataLimitMb: 20480,
      creditBalanceUsd: 18.00,
      expiryDate: new Date(Date.now() + 1000 * 60 * 60 * 24 * 12).toISOString(),
      isLapsed: false,
      isAboutToLapse: false,
    },
  },
  {
    id: 'cam-005',
    serial: 'VST-77291-EXP',
    name: 'Sinkor ATM Kiosk 12',
    model: 'The Eye 4G',
    ownerId: 'cust-103',
    ownerName: 'Ecobank Liberia',
    ownerEmail: 'infrastructure@ecobank.lr',
    status: 'offline',
    vuid: 'LR0077291VUID',
    vuidState: 'resolved',
    relayCluster: 'relay-cluster-monrovia',
    relayHost: 'relay-03.lr.mywatchman.net',
    isRelayReachable: false,
    hasLocation: true,
    latitude: 6.2941,
    longitude: -10.7812,
    address: 'Tubman Blvd, 12th Street Sinkor',
    lastHeartbeat: new Date(Date.now() - 1000 * 60 * 60 * 6).toISOString(),
    isBlocked: false,
    firmwareVersion: 'v47.9.88',
    sdkVersion: 'Eye4-v6.7.0',
    offlineReason: 'relay_mismatch',
    offlineReasonDetail: 'Assigned relay rly-03 failed heartbeats; camera fails handshake route',
    cloudRecording: {
      isRecording: false,
      lastClipTime: new Date(Date.now() - 1000 * 60 * 60 * 6).toISOString(),
      retentionDays: 90,
      status: 'stopped',
    },
    sim: {
      id: 'sim-05',
      deviceId: 'cam-005',
      deviceSerial: 'VST-77291-EXP',
      iccid: '8923100018274619287',
      carrier: 'Orange Liberia',
      signalDbm: -84,
      dataUsageMb: 6100,
      dataLimitMb: 10240,
      creditBalanceUsd: 12.00,
      expiryDate: new Date(Date.now() + 1000 * 60 * 60 * 24 * 9).toISOString(),
      isLapsed: false,
      isAboutToLapse: false,
    },
  },
  {
    id: 'cam-006',
    serial: 'VST-88301-CBL',
    name: 'Congo Town Vault Backdoor',
    model: 'The Eye Mini Solar',
    ownerId: 'cust-103',
    ownerName: 'Ecobank Liberia',
    ownerEmail: 'infrastructure@ecobank.lr',
    status: 'degraded',
    vuid: 'LR0088301VUID',
    vuidState: 'resolved',
    relayCluster: 'relay-cluster-monrovia',
    relayHost: 'relay-01.lr.mywatchman.net',
    isRelayReachable: true,
    hasLocation: true,
    latitude: 6.2754,
    longitude: -10.7419,
    address: 'Tubman Blvd, Congo Town, Monrovia',
    lastHeartbeat: new Date(Date.now() - 1000 * 75).toISOString(),
    isBlocked: false,
    firmwareVersion: 'v48.2.11-build2025',
    sdkVersion: 'Eye4-v6.8.1-linux',
    offlineReason: 'healthy',
    cloudRecording: {
      isRecording: true,
      lastClipTime: new Date(Date.now() - 1000 * 240).toISOString(),
      retentionDays: 90,
      status: 'lagging',
    },
    sim: {
      id: 'sim-06',
      deviceId: 'cam-006',
      deviceSerial: 'VST-88301-CBL',
      iccid: '8923100018274619288',
      carrier: 'Lonestar MTN Liberia',
      signalDbm: -112, // weak signal
      dataUsageMb: 9800,
      dataLimitMb: 10240,
      creditBalanceUsd: 1.10,
      expiryDate: new Date(Date.now() + 1000 * 60 * 60 * 28).toISOString(), // ~1 day left
      isLapsed: false,
      isAboutToLapse: true,
      lastTopupDate: '2026-08-16T14:10:00Z',
    },
  },
  {
    id: 'cam-007',
    serial: 'VST-99102-RES',
    name: 'Royal Grand Hotel Reception',
    model: 'The Eye 4G',
    ownerId: 'cust-104',
    ownerName: 'Royal Grand Hotel',
    ownerEmail: 'management@royalgrandhotel.lr',
    status: 'online',
    vuid: 'LR0099102VUID',
    vuidState: 'resolved',
    relayCluster: 'relay-cluster-monrovia',
    relayHost: 'relay-01.lr.mywatchman.net',
    isRelayReachable: true,
    hasLocation: true,
    latitude: 6.2912,
    longitude: -10.7745,
    address: '15th Street Sinkor, Monrovia',
    lastHeartbeat: new Date(Date.now() - 1000 * 20).toISOString(),
    isBlocked: false,
    firmwareVersion: 'v49.1.02',
    sdkVersion: 'Eye4-v6.8.1-linux',
    offlineReason: 'healthy',
    cloudRecording: {
      isRecording: true,
      lastClipTime: new Date(Date.now() - 1000 * 60).toISOString(),
      retentionDays: 30,
      status: 'healthy',
    },
    sim: {
      id: 'sim-07',
      deviceId: 'cam-007',
      deviceSerial: 'VST-99102-RES',
      iccid: '8923100018274619289',
      carrier: 'Orange Liberia',
      signalDbm: -65,
      dataUsageMb: 3200,
      dataLimitMb: 10240,
      creditBalanceUsd: 20.00,
      expiryDate: new Date(Date.now() + 1000 * 60 * 60 * 24 * 22).toISOString(),
      isLapsed: false,
      isAboutToLapse: false,
    },
  },
  {
    id: 'cam-008',
    serial: 'VST-11004-RES',
    name: 'Mamba Point Residence Gate',
    model: 'The Eye Mini Solar',
    ownerId: 'cust-105',
    ownerName: 'Diplomatic Enclave Residence',
    ownerEmail: 'security@diplo-mamba.com',
    status: 'offline',
    vuid: 'LR0011004VUID',
    vuidState: 'resolved',
    relayCluster: 'relay-cluster-monrovia',
    relayHost: 'relay-01.lr.mywatchman.net',
    isRelayReachable: true,
    hasLocation: true,
    latitude: 6.3198,
    longitude: -10.8142,
    address: 'United Nations Drive, Mamba Point',
    lastHeartbeat: new Date(Date.now() - 1000 * 60 * 60 * 22).toISOString(),
    isBlocked: false,
    firmwareVersion: 'v48.1.10',
    sdkVersion: 'Eye4-v6.8.0',
    offlineReason: 'power_network',
    offlineReasonDetail: 'Solar battery controller dropped below 10.2V; zero heartbeat for 22h',
    cloudRecording: {
      isRecording: false,
      lastClipTime: new Date(Date.now() - 1000 * 60 * 60 * 22).toISOString(),
      retentionDays: 30,
      status: 'stopped',
    },
    sim: {
      id: 'sim-08',
      deviceId: 'cam-008',
      deviceSerial: 'VST-11004-RES',
      iccid: '8923100018274619290',
      carrier: 'Lonestar MTN Liberia',
      signalDbm: -82,
      dataUsageMb: 4500,
      dataLimitMb: 10240,
      creditBalanceUsd: 8.50,
      expiryDate: new Date(Date.now() + 1000 * 60 * 60 * 24 * 14).toISOString(),
      isLapsed: false,
      isAboutToLapse: false,
    },
  }
];

export const MOCK_CUSTOMERS: Customer[] = [
  {
    id: 'cust-101',
    name: 'Monrovia Breweries Ltd',
    email: 'ops@monrovia-breweries.com',
    phone: '+231 77 555 0101',
    joinedAt: '2025-04-12T10:00:00Z',
    cameraCount: 14,
    activePlan: 'Enterprise Tier',
    billingStatus: 'active',
    renewalDate: '2026-10-12',
    isBlocked: false,
    lastLoginAt: '2026-09-14T11:20:00Z',
    notes: 'Major industrial brewery site. High priority customer.',
  },
  {
    id: 'cust-102',
    name: 'APM Terminals Freeport',
    email: 'security@apmterminals.lr',
    phone: '+231 88 555 0202',
    joinedAt: '2025-01-20T08:00:00Z',
    cameraCount: 28,
    activePlan: 'Enterprise Tier',
    billingStatus: 'active',
    renewalDate: '2026-11-20',
    isBlocked: false,
    lastLoginAt: '2026-09-14T15:40:00Z',
  },
  {
    id: 'cust-103',
    name: 'Ecobank Liberia',
    email: 'infrastructure@ecobank.lr',
    phone: '+231 77 555 0303',
    joinedAt: '2025-06-15T14:30:00Z',
    cameraCount: 42,
    activePlan: 'Enterprise Tier',
    billingStatus: 'past_due',
    renewalDate: '2026-09-15',
    isBlocked: false,
    lastLoginAt: '2026-09-13T09:12:00Z',
    notes: 'Finance department invoice pending approval.',
  },
  {
    id: 'cust-104',
    name: 'Royal Grand Hotel',
    email: 'management@royalgrandhotel.lr',
    phone: '+231 88 555 0404',
    joinedAt: '2025-08-01T12:00:00Z',
    cameraCount: 8,
    activePlan: 'Business Pro',
    billingStatus: 'active',
    renewalDate: '2026-10-01',
    isBlocked: false,
    lastLoginAt: '2026-09-14T08:00:00Z',
  },
  {
    id: 'cust-105',
    name: 'Diplomatic Enclave Residence',
    email: 'security@diplo-mamba.com',
    phone: '+231 77 555 0505',
    joinedAt: '2025-11-10T16:20:00Z',
    cameraCount: 4,
    activePlan: 'Standard Cloud',
    billingStatus: 'active',
    renewalDate: '2026-11-10',
    isBlocked: false,
    lastLoginAt: '2026-09-12T18:45:00Z',
  },
];

export const MOCK_CUSTOMER_FLEETS: CustomerFleetSummary[] = [
  {
    customerId: 'cust-101',
    customerName: 'Monrovia Breweries Ltd',
    customerEmail: 'ops@monrovia-breweries.com',
    customerPhone: '+231 77 555 0101',
    totalCameras: 14,
    onlineCameras: 13,
    offlineCameras: 1,
    isSiteFullyDown: false,
    planName: 'Enterprise Tier',
    offlineDevices: [
      {
        deviceId: 'cam-001',
        serial: 'VST-48201-LRB',
        name: 'Main Gate Entrance 0776550101',
        lastSeenAt: new Date(Date.now() - 1000 * 60 * 180).toISOString(),
        reason: 'needs_reactivation',
        eye4State: 'inactivated',
        namePhone: '0776550101',
      },
    ],
  },
  {
    customerId: 'cust-102',
    customerName: 'APM Terminals Freeport',
    customerEmail: 'security@apmterminals.lr',
    customerPhone: '+231 88 555 0202',
    totalCameras: 28,
    onlineCameras: 27,
    offlineCameras: 1,
    isSiteFullyDown: false,
    planName: 'Enterprise Tier',
    offlineDevices: [
      {
        deviceId: 'cam-003',
        serial: 'VST-59104-ROV',
        name: 'Freeport Pier 3 Loading Bay',
        lastSeenAt: new Date(Date.now() - 1000 * 60 * 12).toISOString(),
        reason: 'reachable_quiet',
        eye4State: 'active',
      },
    ],
  },
  {
    customerId: 'cust-103',
    customerName: 'Ecobank Liberia',
    customerEmail: 'infrastructure@ecobank.lr',
    customerPhone: '+231 77 555 0303',
    totalCameras: 42,
    onlineCameras: 40,
    offlineCameras: 2,
    isSiteFullyDown: false,
    planName: 'Enterprise Tier',
    offlineDevices: [
      {
        deviceId: 'cam-005',
        serial: 'VST-77291-EXP',
        name: 'Sinkor ATM Kiosk 0778550312',
        lastSeenAt: new Date(Date.now() - 1000 * 60 * 60 * 6).toISOString(),
        reason: 'unresolved',
        namePhone: '0778550312',
      },
    ],
  },
  {
    customerId: 'cust-105',
    customerName: 'Diplomatic Enclave Residence',
    customerEmail: 'security@diplo-mamba.com',
    customerPhone: '+231 77 555 0505',
    totalCameras: 4,
    onlineCameras: 3,
    offlineCameras: 1,
    isSiteFullyDown: false,
    planName: 'Standard Cloud',
    offlineDevices: [
      {
        deviceId: 'cam-008',
        serial: 'VST-11004-RES',
        name: 'Mamba Point Residence Gate',
        lastSeenAt: new Date(Date.now() - 1000 * 60 * 60 * 22).toISOString(),
        reason: 'never_reported',
      },
    ],
  },
];

export const MOCK_ALERTS: AlertItem[] = [
  {
    id: 'alt-9921',
    deviceId: 'cam-001',
    deviceSerial: 'VST-48201-LRB',
    deviceName: 'Main Gate Entrance (PTZ)',
    ownerName: 'Monrovia Breweries Ltd',
    type: 'sim_expiry',
    severity: 'critical',
    status: 'active',
    timestamp: new Date(Date.now() - 1000 * 60 * 180).toISOString(),
    message: 'SIM data lapsed: Eye4 server rejected with 550 inactivated',
  },
  {
    id: 'alt-9920',
    deviceId: 'cam-003',
    deviceSerial: 'VST-59104-ROV',
    deviceName: 'Freeport Pier 3 Loading Bay',
    ownerName: 'APM Terminals Freeport',
    type: 'offline',
    severity: 'critical',
    status: 'active',
    timestamp: new Date(Date.now() - 1000 * 60 * 15).toISOString(),
    message: 'P2P streaming session timed out on relay-02.lr.mywatchman.net',
  },
  {
    id: 'alt-9919',
    deviceId: 'cam-006',
    deviceSerial: 'VST-88301-CBL',
    deviceName: 'Congo Town Vault Backdoor',
    ownerName: 'Ecobank Liberia',
    type: 'sim_expiry',
    severity: 'warning',
    status: 'active',
    timestamp: new Date(Date.now() - 1000 * 60 * 75).toISOString(),
    message: 'SIM data bundle below 5% threshold (440 MB remaining)',
  },
  {
    id: 'alt-9918',
    deviceId: 'cam-004',
    deviceSerial: 'VST-59105-ROV',
    deviceName: 'Customs Warehouse Entrance',
    ownerName: 'APM Terminals Freeport',
    type: 'motion',
    severity: 'info',
    status: 'acknowledged',
    timestamp: new Date(Date.now() - 1000 * 60 * 110).toISOString(),
    message: 'Human detection alarm verified outside scheduled operating hours',
    acknowledgedBy: 'tech@mywatchman.com',
    acknowledgedAt: new Date(Date.now() - 1000 * 60 * 95).toISOString(),
  },
];

export const MOCK_SUBSCRIPTIONS: Subscription[] = [
  {
    id: 'sub-001',
    customerId: 'cust-101',
    customerName: 'Monrovia Breweries Ltd',
    planSlug: 'enterprise-tier',
    planName: 'Enterprise Tier',
    status: 'active',
    currentPeriodStart: '2026-09-12T00:00:00Z',
    currentPeriodEnd: '2026-10-12T00:00:00Z',
    amountUsd: 650.00,
    billingCycle: 'monthly',
    entitlements: {
      cloudCameraLimit: 25,
      retentionDays: 30,
      aiFeatures: ['human_detection', 'vehicle_lpr', 'perimeter_guard', 'line_crossing'],
    },
  },
  {
    id: 'sub-002',
    customerId: 'cust-102',
    customerName: 'APM Terminals Freeport',
    planSlug: 'enterprise-tier',
    planName: 'Enterprise Tier',
    status: 'active',
    currentPeriodStart: '2026-08-20T00:00:00Z',
    currentPeriodEnd: '2026-11-20T00:00:00Z',
    amountUsd: 1200.00,
    billingCycle: 'monthly',
    entitlements: {
      cloudCameraLimit: 50,
      retentionDays: 60,
      aiFeatures: ['human_detection', 'vehicle_lpr', 'perimeter_guard', 'smoke_fire_alert'],
    },
  },
  {
    id: 'sub-003',
    customerId: 'cust-103',
    customerName: 'Ecobank Liberia',
    planSlug: 'enterprise-tier',
    planName: 'Enterprise Tier',
    status: 'past_due',
    currentPeriodStart: '2026-08-15T00:00:00Z',
    currentPeriodEnd: '2026-09-15T00:00:00Z',
    amountUsd: 1850.00,
    billingCycle: 'monthly',
    entitlements: {
      cloudCameraLimit: 100,
      retentionDays: 90,
      aiFeatures: ['human_detection', 'vehicle_lpr', 'perimeter_guard', 'sos_auto_dispatch'],
    },
    dunningStatus: 'dunning_stage_1',
  },
];

export const MOCK_PAYMENTS: PaymentRecord[] = [
  {
    id: 'pay-771',
    customerId: 'cust-101',
    customerName: 'Monrovia Breweries Ltd',
    planName: 'Enterprise Tier',
    amountUsd: 650.00,
    status: 'succeeded',
    method: 'bank_transfer',
    reference: 'TXN-MBL-20260912-441',
    createdAt: '2026-09-12T14:32:00Z',
  },
  {
    id: 'pay-770',
    customerId: 'cust-102',
    customerName: 'APM Terminals Freeport',
    planName: 'Enterprise Tier',
    amountUsd: 1200.00,
    status: 'succeeded',
    method: 'bank_transfer',
    reference: 'TXN-APM-20260820-998',
    createdAt: '2026-08-20T10:15:00Z',
  },
  {
    id: 'pay-769',
    customerId: 'cust-103',
    customerName: 'Ecobank Liberia',
    planName: 'Enterprise Tier',
    amountUsd: 1850.00,
    status: 'failed',
    method: 'card',
    reference: 'TXN-ECO-20260915-001',
    createdAt: '2026-09-15T01:05:00Z',
  },
  {
    id: 'pay-768',
    customerId: 'cust-104',
    customerName: 'Royal Grand Hotel',
    planName: 'Business Pro',
    amountUsd: 280.00,
    status: 'succeeded',
    method: 'momo',
    reference: 'LONESTAR-MOMO-882194',
    createdAt: '2026-09-01T09:44:00Z',
  },
];

export const MOCK_PLANS: PlanItem[] = [
  {
    slug: 'standard-cloud',
    name: 'Standard Cloud',
    priceMonthlyUsd: 35.00,
    priceYearlyUsd: 380.00,
    cloudCameraLimit: 4,
    retentionDays: 14,
    aiFeatures: ['human_detection'],
    isActive: true,
  },
  {
    slug: 'business-pro',
    name: 'Business Pro',
    priceMonthlyUsd: 95.00,
    priceYearlyUsd: 1040.00,
    cloudCameraLimit: 12,
    retentionDays: 30,
    aiFeatures: ['human_detection', 'vehicle_lpr', 'perimeter_guard'],
    isActive: true,
  },
  {
    slug: 'enterprise-tier',
    name: 'Enterprise Tier',
    priceMonthlyUsd: 250.00,
    priceYearlyUsd: 2750.00,
    cloudCameraLimit: 50,
    retentionDays: 90,
    aiFeatures: ['human_detection', 'vehicle_lpr', 'perimeter_guard', 'sos_auto_dispatch', 'smoke_fire_alert'],
    isActive: true,
  },
];

export const MOCK_INVENTORY: InventoryItem[] = [
  {
    id: 'inv-01',
    sku: 'VST-CG664-4G',
    name: 'The Eye 4G LTE PTZ Camera',
    model: 'CG664-4G',
    quantityOnHand: 18,
    lowStockThreshold: 10,
    unitCostUsd: 72.00,
    retailPriceUsd: 145.00,
    category: 'camera',
    updatedAt: '2026-09-10T12:00:00Z',
  },
  {
    id: 'inv-02',
    sku: 'VST-CS668-SOLAR',
    name: 'The Eye Solar Cellular Camera',
    model: 'CS668-Solar',
    quantityOnHand: 4,
    lowStockThreshold: 8, // flagged as low stock!
    unitCostUsd: 110.00,
    retailPriceUsd: 220.00,
    category: 'camera',
    updatedAt: '2026-09-12T16:40:00Z',
  },
  {
    id: 'inv-03',
    sku: 'SIM-MTN-LTE-MWM',
    name: 'Lonestar MTN M2M Industrial SIM Card',
    model: 'M2M-LTE-M',
    quantityOnHand: 42,
    lowStockThreshold: 20,
    unitCostUsd: 3.50,
    retailPriceUsd: 10.00,
    category: 'sim',
    updatedAt: '2026-09-14T09:10:00Z',
  },
  {
    id: 'inv-04',
    sku: 'MWM-BATT-SOL-20AH',
    name: '20Ah Lithium LifePO4 Solar Battery Pack',
    model: 'MWM-LIFEPO4-20',
    quantityOnHand: 3,
    lowStockThreshold: 5, // flagged as low stock!
    unitCostUsd: 48.00,
    retailPriceUsd: 95.00,
    category: 'accessory',
    updatedAt: '2026-09-11T14:20:00Z',
  },
];


export const MOCK_EMERGENCIES: EmergencyEvent[] = [
  {
    id: 'sos-108',
    type: 'sos_button',
    deviceId: 'cam-007',
    deviceSerial: 'VST-99102-RES',
    customerName: 'Royal Grand Hotel',
    location: '15th Street Sinkor, Reception Counter',
    latitude: 6.2912,
    longitude: -10.7745,
    status: 'dispatched',
    reportedAt: new Date(Date.now() - 1000 * 60 * 18).toISOString(),
    timeline: [
      {
        timestamp: new Date(Date.now() - 1000 * 60 * 18).toISOString(),
        event: 'Physical SOS panic button pressed at hotel reception',
        actor: 'Receptionist (Hardware SOS)',
      },
      {
        timestamp: new Date(Date.now() - 1000 * 60 * 16).toISOString(),
        event: 'MWM SOS Bridge notified Liberia National Police Sector 2',
        actor: 'mcp-sos-client',
      },
      {
        timestamp: new Date(Date.now() - 1000 * 60 * 12).toISOString(),
        event: 'Armed response patrol unit dispatched (ETA 7 mins)',
        actor: 'Dispatcher Unit #4',
      },
    ],
  },
];

export const MOCK_ADMINS: AdminUser[] = [
  {
    id: 'usr-super-01',
    name: 'Alex Vance (Platform Lead)',
    email: 'superadmin@mywatchman.com',
    role: 'super_admin',
    permissions: [],
    mfaEnabled: true,
    lastLogin: '2026-09-14T17:00:00Z',
    createdAt: '2025-01-01T00:00:00Z',
    isActive: true,
  },
  {
    id: 'usr-admin-01',
    name: 'Sarah Jenkins (Ops Director)',
    email: 'admin@mywatchman.com',
    role: 'admin',
    permissions: [],
    mfaEnabled: true,
    lastLogin: '2026-09-14T16:30:00Z',
    createdAt: '2025-02-15T00:00:00Z',
    isActive: true,
  },
  {
    id: 'usr-tech-01',
    name: 'David Tamba (Field Tech Lead)',
    email: 'tech@mywatchman.com',
    role: 'operator',
    permissions: [],
    mfaEnabled: true,
    lastLogin: '2026-09-14T17:15:00Z',
    createdAt: '2025-03-01T00:00:00Z',
    isActive: true,
  },
  {
    id: 'usr-fin-01',
    name: 'Grace Barclay (Head of Finance)',
    email: 'finance@mywatchman.com',
    role: 'admin',
    permissions: [],
    mfaEnabled: true,
    lastLogin: '2026-09-14T14:10:00Z',
    createdAt: '2025-03-10T00:00:00Z',
    isActive: true,
  },
  {
    id: 'usr-sup-01',
    name: 'Marcus Toe (Tier-1 Support)',
    email: 'support@mywatchman.com',
    role: 'operator',
    permissions: [],
    mfaEnabled: false,
    lastLogin: '2026-09-14T16:50:00Z',
    createdAt: '2025-05-20T00:00:00Z',
    isActive: true,
  },
];

